import { jsx } from "react/jsx-runtime";
import TextSnippetOutlinedIcon from "@mui/icons-material/TextSnippetOutlined";
import { validateTidalLicense } from "../../base/index.js";
function TextSnippetOutlined(props) {
  return /* @__PURE__ */ jsx(
    TextSnippetOutlinedIcon,
    {
      "data-testid": "TextSnippetOutlined",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "TextSnippetOutlined",
      "data-tidal-icon-meta": "folders,notes,lists"
    }
  );
}
TextSnippetOutlined.tidalIconMeta = {
  categories: "folders,notes,lists",
  name: "TextSnippetOutlined"
};
validateTidalLicense();
export {
  TextSnippetOutlined
};
//# sourceMappingURL=TextSnippetOutlined.js.map
